export default {
  float(amount) {
    return parseFloat(amount).toFixed(2);
  },
  rmEmpty(aData) {
    var s = []
    var n = 0
    for (var i in aData) {
      if (aData[i]) {
        s[n++] = aData[i]
      }
    }
    return s.join(',')
  },
  price_range(prices) {
    return this.arr_min_max(prices)
  },
  market_price_range(market_prices) {
    return this.arr_min_max(market_prices)
  },
  arr_min_max(arr) {
    let list = [this.float(Math.min.apply(null, arr)), this.float(Math.max.apply(null, arr))]
    if (list[0] != list[1]) {
      return list.join('~')
    }
    return list[0]
  },
  onSelectAttr(index, value,that) {
    if (value.cls == 'disabled') return
    if (that.selectAttrId[index] && that.selectAttrId[index] == value.id) {
      that.selectAttrId[index] = ''
    } else {
      that.selectAttrId[index] = value.id
    }
    let is_select = false
    for (var i in that.selectAttrId) {
      if (that.selectAttrId[i]) {
        is_select = true
      }
    }
    if (is_select) {
      for (var i in that.selectAttrId) {
        var s = that.selectAttrId[i]
        var temp = Object.assign([], that.selectAttrId)
        for (var ii in that.attrs.list[i].list) {
          temp[i] = ii
          var t = this.rmEmpty(temp)
          if (!that.info.all_sku[t] || that.info.all_sku[t].available < 1) {
            that.attrs.list[i].list[ii].cls = 'disabled'
          } else {
            that.attrs.list[i].list[ii].cls = ''
          }
        }
      }
    }

    var arr = that.selectAttrId.join(',')
    let postData = that.postData
    let change = true
    let temp_inv = postData.available
    let temp_price = ''
    let market_price = ''
    let inventory = that.attrs
    let num = postData.num
    if (inventory.inv[arr]) {
      if (inventory.inv[arr].available > 0) {
        postData.available = inventory.inv[arr].available
        postData.price = inventory.inv[arr].price
        postData.attr_ids = arr
        postData.attr_name = inventory.inv[arr].attr_name
        postData.num = postData.available > 0 ? postData.min_num : 0
        temp_inv = postData.available
      } else {
        change = false
      }
      temp_price = this.float(postData.price)
      market_price = this.float(inventory.inv[arr].market_price)
    } else {
      postData.available = 0
      postData.price = ' - '
      postData.attr_ids = ''
      postData.attr_name = ''
      postData.num = 0
      temp_inv = postData.available
      var r = this.rmEmpty(that.selectAttrId)
      if (!that.info.all_sku[r] || that.info.all_sku[r].available < 1) {
        temp_price = ''
        market_price = ''
        if (!that.info.all_sku[r]) {
          temp_inv = that.info.inventory.row.available
        }
      } else {
        temp_inv = that.info.all_sku[r].available
        temp_price = this.arr_min_max(that.info.all_sku[r].prices)
        market_price = this.arr_min_max(that.info.all_sku[r].market_prices)

      }
    }
    if (!temp_price) {
      temp_price = that.htmlData.o.price
      market_price = that.htmlData.o.market_price
    }

    that.htmlData.n.price = temp_price
    that.htmlData.n.market_price = market_price

    that.htmlData.total = temp_inv
    that.htmlData.n.img = value.img ? value.img : that.htmlData.o.img

    if (change) {
      that.numberData = {
        min: postData.num,
        max: Math.min(postData.limit_num, postData.available),
      }
      if (num >= that.numberData.min && num <= that.numberData.max) {
        postData.num = num
      }else if(num > that.numberData.max){
        postData.num = that.numberData.max
      }else if(num < that.numberData.min){
        postData.num = that.numberData.min
      }
    }
    that.postData = Object.assign({}, postData)
    that.htmlData = Object.assign({}, that.htmlData)
    that.attrs = Object.assign({}, that.attrs)
    that.selectAttrId = Object.assign([], that.selectAttrId)
  },
  goods_checkout(that,data,url) {
    if(data.length < 1)return
    let list = []
    for (var i in data) {
        list[i] = {}
        list[i].goods_id = data[i].goods_id
        list[i].attr_ids = data[i].attr_ids
        list[i].attr_name = data[i].attr_name
        list[i].goods_name = data[i].goods_name ? data[i].goods_name : data[i].title
        list[i].num = data[i].num
    }
    that._func.dataStorage(url, list)
    that.$router.push({
        path: url,
    })
  },
}
